import React, { Component } from 'react';
import axios from "axios";
import Api from "../../customlib/Api";
import moment from "moment";
import ExportLeadsReport from './ExportLeadsReport';
import Global from "../../customlib/Global"


import { makeStyles } from '@mui/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton, Box, Typography, CircularProgress, Grid, LinearProgress} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Search } from '@mui/icons-material';
import DateRangePicker from '../../customlib/DateRangePicker';
import EventReminderReportMobile from '../DashboardTele/DashboardTeleMobile/EventReminderReportMobile';

class DashboardBlast extends Component {
    state = { 
        contactLeads : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        page: 0,
        rowsPerPage: 30,
        value: '0',
        isTeleReport: true,
        isLoading: false,
        totalDatabase: 0,
        totalTereksekusi: 0,
        totalManual: 0,
        totalFu: 0,
        totalSpent: 0,
        totalSent: 0,
        totalDelivered: 0,
        totalRead: 0,
        totalReplied: 0,
        totalFailed: 0,
        totalPending: 0,
        totalRejected: 0,
        messageSent: [],
        messageDelivered: []
    }
    
    componentDidMount() {
        this.getContactLeads();
    }

    getContactLeads = () => {
      console.log("STARTDATE : ",this.state.startDate);
      var userData = Global.get();
      console.log("USERDATA : ", userData);
      console.log("USERDATA", userData);

      this.setState({contactLeads: [], isLoading: true});

      axios
        .post(Api.blastSummary(), {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            appProfileId: Global.getAppProfile()._id
        }, Api.getRequestHeader())
        .then((response) => {
          console.log("CONTACTLEADS : ", response.data);
          console.log("USERDATA : ", "wkwkwk");
          
          var tmpContactLeads = response.data.data;
          
          if(userData.admin === false && Global.isTeleAdmin() === false && Global.isAdminTeleUser() === false){
            // tmpContactLeads = tmpContactLeads.filter(element => element.salesId === userData.user.id);
          }

          let totalDatabase = 0;
          let totalTereksekusi = 0;
          let totalManual = 0;
          let totalFu = 0;
          let totalSpent = 0;

          let totalSent = 0;
          let totalDelivered = 0;
          let totalRead = 0;
          let totalReplied = 0;
          let totalFailed = 0;
          let totalPending = 0;
          let totalRejected = 0;

          let messageSent = [];//{hsmName, total, totalBlast, totalManual, totalRespon, totalResponBlast, totalResponManual}
          let messageDelivered = [];

          tmpContactLeads.forEach(byDate => {
            totalDatabase += byDate.countCustomerToday;
            totalTereksekusi += byDate.countExecuted;
            totalManual += byDate.logs.filter(item => item.sendType !== "BLAST").length;
            totalFu = totalTereksekusi + totalManual;
            byDate.logs.forEach(item => {
              totalSpent += item.price;

              totalSent += 1;
              totalDelivered += item.deliveredAt ? 1 : 0;
              totalRead += item.readAt ? 1 : 0;
              totalReplied += 0;
              totalFailed += 0;
              totalPending += 0;
              totalRejected += item.rejectedAt ? 1 : 0;

              let findHsmSent = messageSent.find(sent => sent.hsmName === item.hsmName);
              if(findHsmSent){
                findHsmSent.total += 1;
                findHsmSent.totalDelivered += item.deliveredAt ? 1 : 0;
                findHsmSent.totalRead += item.ReadAt ? 1 : 0;
                findHsmSent.totalRejected += item.rejectedAt ? 1 : 0;
                findHsmSent.totalBlast += item.sendType === "BLAST" ? 1 : 0;
                findHsmSent.totalManual += item.sendType !== "BLAST" ? 1 : 0;
                findHsmSent.totalRespon += 0;
                findHsmSent.totalResponBlast += 0;
                findHsmSent.totalResponManual += 0;
              }else{
                messageSent.push(
                  {
                    hsmName: item.hsmName,
                    total: 1,
                    totalDelivered: item.deliveredAt ? 1 : 0,
                    totalRead: item.readAt ? 1 : 0,
                    totalRejected: item.rejectedAt ? 1 : 0,
                    totalBlast: item.sendType === "BLAST" ? 1 : 0,
                    totalManual: item.sendType !== "BLAST" ? 1 : 0,
                    totalRespon: 0,
                    totalResponBlast: 0,
                    totalResponManual: 0
                  }
                );
              }

              // let findHsmDelivered = messageSent.find(sent => sent.hsmName === item.hsmName);
              // if(findHsmSent){
              //   findHsmSent.total += 1;
              //   findHsmSent.totalBlast += item.sendType === "BLAST" ? 1 : 0;
              //   findHsmSent.totalManual += item.sendType !== "BLAST" ? 1 : 0;
              //   findHsmSent.totalRespon += 0;
              //   findHsmSent.totalResponBlast += 0;
              //   findHsmSent.totalResponManual += 0;
              // }else{
              //   messageSent.push(
              //     {
              //       hsmName: item.hsmName,
              //       total: 1,
              //       totalBlast: item.sendType === "BLAST" ? 1 : 0,
              //       totalManual: item.sendType !== "BLAST" ? 1 : 0,
              //       totalRespon: 0,
              //       totalResponBlast: 0,
              //       totalResponManual: 0
              //     }
              //   );
              // }

            });
          });

          this.setState({
            contactLeads: tmpContactLeads, 
            totalDatabase: totalDatabase,
            totalTereksekusi: totalTereksekusi,
            totalManual: totalManual,
            totalFu: totalFu,
            totalSpent: totalSpent,

            totalSent: totalSent,
            totalDelivered: totalDelivered,
            totalRead: totalRead,
            totalReplied: totalReplied,
            totalFailed: totalFailed,
            totalPending: totalPending,
            totalRejected: totalRejected,

            messageSent: messageSent,
            isLoading: false
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    };

    handleStartDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ startDate:  formatStartDate}, this.getContactLeads);
        // this.state.startDate = formatStartDate;
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleEndDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ endDate:  formatStartDate}, this.getContactLeads);
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDate: startDate, endDate:  endDate}, this.getContactLeads);
    }

    columns = [
        { id: 'salesName', label: 'Sales', minWidth: 170 },
        { id: 'leadsCount', label: 'Jumlah Follow Up', minWidth: 100 }
    ];

    render() { 

        if(this.props.isMobile){
          return (
            <EventReminderReportMobile 
              {...this.props}
              state={this.state}
              onDateChanged={this.handleDateChanged}
              onSearch={this.getContactLeads}
            />
          );
        }

        return ( 
          <Paper elevation={0} style={{padding: "0px"}}>
            <Grid container spacing={1}>
                <Grid item xs={3} className="col-3">
                    <strong>Total {this.state.contactLeads.length} Salesman</strong>
                </Grid>
                <Grid item xs={8} textAlign={"right"}>
                  <DateRangePicker onDateChanged={this.handleDateChanged} />
                </Grid>
                <Grid item xs={1}>
                  <IconButton color='primary' onClick={this.getContactLeads}>
                    <Search />
                  </IconButton>
                {/* {
                      this.state.isLoading === true ? 
                          (<CircularProgress style={{marginTop: 15}} size={30} color="secondary" />) : 
                          (<div onClick={() => {this.getContactLeads()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>)
                  } */}
                </Grid>
            </Grid>
            {
              this.state.isLoading && <LinearProgress sx={{mt: "10px", mb: "10px"}} />
            }

            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TableContainer>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Status</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Total Database</TableCell>
                        <TableCell>{this.state.totalDatabase}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Total FU Tereksekusi Lotus</TableCell>
                        <TableCell>{this.state.totalTereksekusi}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Total FU Manual</TableCell>
                        <TableCell>{this.state.totalManual}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Total Keseluruhan FU</TableCell>
                        <TableCell>{this.state.totalFu}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Total Spent</TableCell>
                        <TableCell>{this.state.totalSpent}&nbsp;&euro;</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={6}>
                <TableContainer>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Status</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Message Sent</TableCell>
                        <TableCell>{this.state.totalSent}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Message Delivery</TableCell>
                        <TableCell>{this.state.totalDelivered}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Message Read</TableCell>
                        <TableCell>{this.state.totalRead}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Message Replies</TableCell>
                        <TableCell>{this.state.totalReplied}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Failed</TableCell>
                        <TableCell>{this.state.totalFailed}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Pending</TableCell>
                        <TableCell>{this.state.totalPending}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{fontWeight: "bold"}}>Rejected</TableCell>
                        <TableCell>{this.state.totalRejected}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>

            <Box>
              <strong>Message Sent</strong>
              <TableContainer>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{fontWeight: "bold"}}>HSM</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Total FU</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Delivery</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Read</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Rejected</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Blast</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Manual</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Respon</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Respon Blast</TableCell>
                      <TableCell sx={{fontWeight: "bold"}}>Respon Manual</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      this.state.messageSent.map(item => {
                        return (
                          <TableRow>
                          <TableCell>{item.hsmName}</TableCell>
                          <TableCell>{item.total}</TableCell>
                          <TableCell>{item.totalDelivered}</TableCell>
                          <TableCell>{item.totalRead}</TableCell>
                          <TableCell>{item.totalRejected}</TableCell>
                          <TableCell>{item.totalBlast}</TableCell>
                          <TableCell>{item.totalManual}</TableCell>
                          <TableCell>{item.totalRespon}</TableCell>
                          <TableCell>{item.totalResponBlast}</TableCell>
                          <TableCell>{item.totalResponManual}</TableCell>
                        </TableRow>
                        );
                      })
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </Paper>
         );
    }
}
 
export default DashboardBlast;

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
});

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
  
    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.salesName}
          </TableCell>
          <TableCell align="left">{row.leadsCount} FU</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  Follow Up Detail
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nama</TableCell>
                      {
                          // Global.get().admin === true ? <TableCell>Nomor WhatsApp</TableCell> : <></>
                      }
                      <TableCell>Nomor WhatsApp</TableCell>
                      <TableCell>Tanggal FU</TableCell>
                      <TableCell>Chat Terakhir</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.leads.map((historyRow) => (
                      <TableRow key={historyRow.id}>
                        <TableCell component="th" scope="row">
                          {historyRow.fromName}
                        </TableCell>
                        {
                            // Global.get().admin === true ? <TableCell>{historyRow.from}</TableCell> : <></>
                        }
                        <TableCell>{Global.maskPhoneNumber(historyRow.from)}</TableCell>
                        <TableCell align="left">{Global.formatDateTimeToStrDateTime24(historyRow.createdAt)}</TableCell>
                        <TableCell align="left">
                          {Global.formatDateTimeToStrDateTime24(historyRow.lastMessageReceivedAt)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }